export default __webpack_public_path__ + "static/media/Message_White.dfb3f851.svg";